export const UPDATE_INVOICE_SUBMIT_FORM_REQUEST = "UPDATE_INVOICE_SUBMIT_FORM_REQUEST";
export const UPDATE_INVOICE_SUBMIT_FORM_SUCCESS = "UPDATE_INVOICE_SUBMIT_FORM_SUCCESS";
export const UPDATE_INVOICE_SUBMIT_FORM_FAILURE = "UPDATE_INVOICE_SUBMIT_FORM_FAILURE";
export const RESET_STATE = "RESET_STATE";
